import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { DossierRunsPanel } from '@/features/admin/DossierRunsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Dossier Runs route — platform operator's view of every in-flight
 * (queued/running) dossier run, with the action to force-fail a wedged one.
 * Bounces to /admin/login if the admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/dossier-runs')({
  component: AdminDossierRunsPage,
});

function AdminDossierRunsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Dossier Runs"
        subtitle="Every dossier run currently queued or running, across all companies. Stale runs (the recovery sweeper would act on them) are highlighted. Kill a wedged run to fail it now instead of waiting for auto-recovery."
      />
      <DossierRunsPanel />
    </AdminShell>
  );
}
